import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Flex,
  Heading,
  HStack,
  Icon,
  SimpleGrid,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaTasks } from 'react-icons/fa';
import LegalModal from '../legal/LegalModal';
import LegalPolicyLinks from '../legal/LegalPolicyLinks';
import { LegalDocType } from '../legal/legalContent';
import { LEGAL } from '../../config/legal';

const LandingFooter: React.FC = () => {
  const bg = useColorModeValue('gray.900', 'black');
  const muted = useColorModeValue('gray.400', 'gray.500');
  const linkHover = useColorModeValue('white', 'gray.200');
  const [legalDoc, setLegalDoc] = useState<LegalDocType | null>(null);

  return (
    <>
      <Box as="footer" bg={bg} color="white" pt={16} pb={8}>
        <Container maxW="7xl">
          <SimpleGrid columns={{ base: 1, md: 4 }} spacing={10} mb={12}>
            <VStack align="start" spacing={4} gridColumn={{ md: 'span 2' }}>
              <HStack spacing={3}>
                <Flex
                  align="center"
                  justify="center"
                  boxSize={10}
                  borderRadius="xl"
                  bgGradient="linear(to-br, blue.500, purple.500)"
                >
                  <Icon as={FaTasks} boxSize={5} />
                </Flex>
                <Heading size="md">{LEGAL.productName}</Heading>
              </HStack>
              <Text color={muted} maxW="sm" lineHeight="tall">
                The all-in-one workspace for software agencies to manage clients, projects, tasks, and
                team delivery.
              </Text>
            </VStack>

            <VStack align="start" spacing={3}>
              <Text fontWeight="semibold">Product</Text>
              <Text as="a" href="#features" color={muted} _hover={{ color: linkHover }}>
                Features
              </Text>
              <Text as="a" href="#pricing" color={muted} _hover={{ color: linkHover }}>
                Pricing
              </Text>
              <Text as={RouterLink} to="/auth" color={muted} _hover={{ color: linkHover }}>
                Sign in
              </Text>
            </VStack>

            <VStack align="start" spacing={3}>
              <Text fontWeight="semibold">Legal</Text>
              <LegalPolicyLinks
                onOpen={setLegalDoc}
                color={muted}
                hoverColor={linkHover}
                layout="vertical"
              />
            </VStack>
          </SimpleGrid>

          <Flex
            direction={{ base: 'column', md: 'row' }}
            justify="space-between"
            align="center"
            gap={4}
            pt={8}
            borderTopWidth="1px"
            borderColor="whiteAlpha.200"
          >
            <Text fontSize="sm" color={muted}>
              © {new Date().getFullYear()} {LEGAL.productName}. All rights reserved.
            </Text>
            <Text fontSize="sm" color={muted}>
              Photos by Unsplash
            </Text>
          </Flex>
        </Container>
      </Box>

      <LegalModal
        doc={legalDoc}
        isOpen={legalDoc !== null}
        onClose={() => setLegalDoc(null)}
        onNavigate={setLegalDoc}
      />
    </>
  );
};

export default LandingFooter;
